import { toastr } from 'react-redux-toastr';
import axiosPublicApi from '../main/axios-public';
import axiosInstance from '../main/axios';
import socketService from '../services/socketService';

// Helper para logar e tentar autenticar
function attemptSocketAuth(source) {
  socketService.tryAuthenticate();
}

export function login(values) {
  return submit(values, `/login`, 'login');
}

export function signup(values) {
  return submit(values, `/signup`, 'signup');
}

// Nova ação para buscar a configuração do cliente
export function getClientConfig() {
  return dispatch => {
    axiosInstance
      .get(`/config/cliente`)
      .then(resp => {
        dispatch({ type: 'CLIENT_CONFIG_FETCHED', payload: resp.data });
      })
      .catch(e => {
        console.error('authActions (getClientConfig): Erro na API!', e);
        toastr.error('Erro', 'Falha ao buscar configuração do cliente.');
      });
  };
}

function submit(values, url, source) {
  return dispatch => {
    axiosPublicApi
      .post(url, values)
      .then(resp => {
        // ---> PASSO CRÍTICO: Salvar dados no localStorage AQUI <---
        if (resp.data) {
          const userKey = '_ssat';
          localStorage.setItem(userKey, JSON.stringify(resp.data));
        } else {
          console.error(`authActions (${source}): Resposta da API não contém dados para salvar!`);
          // Considerar não prosseguir se não houver dados
        }

        // Agora que o localStorage FOI setado, despacha a ação para o Redux
        dispatch([{ type: 'USER_FETCHED', payload: resp.data }]);

        // Busca a configuração do cliente
        dispatch(getClientConfig());

        // E AGORA podemos tentar autenticar o socket com segurança
        attemptSocketAuth(source);
      })
      .catch(e => {
        console.error(`authActions (${source}): Erro na API!`, e);
        console.error('authActions: Detalhes do Erro:', e.response);
        if (e.response && e.response.data && e.response.data.errors) {
          e.response.data.errors.forEach(error => toastr.error('Erro', error));
        } else {
          toastr.error('Erro', 'Falha na comunicação com o servidor. Verifique o console.');
        }
      });
  };
}

export function logout() {
  socketService.disconnect();
  const userKey = '_ssat';
  localStorage.removeItem(userKey);

  const notificationsKey = '_ssat_notifications';
  localStorage.removeItem(notificationsKey);

  return { type: 'TOKEN_VALIDATED', payload: false };
}

export function validateToken(token) {
  return dispatch => {
    if (token) {
      axiosPublicApi
        .post(`/validateToken`, { token })
        .then(resp => {
          dispatch({ type: 'TOKEN_VALIDATED', payload: resp.data.valid });

          if (resp.data.valid) {
            attemptSocketAuth('validateToken');
            dispatch(getClientConfig());
          } else {
            const userKey = '_ssat';
            localStorage.removeItem(userKey);
          }
        })
        .catch(e => {
          console.error('authActions (validateToken): Erro na API!:', e);
          console.error('authActions: Detalhes do Erro:', e.response);
          dispatch({ type: 'TOKEN_VALIDATED', payload: false });
          const userKey = '_ssat';
          localStorage.removeItem(userKey);
        });
    } else {
      dispatch({ type: 'TOKEN_VALIDATED', payload: false });
      const userKey = '_ssat';
      localStorage.removeItem(userKey);
    }
  };
}
